import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { SEARCH_INTENT_RESOURCES_SUGGESTIONS } from "./gql";

const useSearchIntentResourcesSuggestions = (intentProjectId: string) => {
  const { data, previousData, loading } = useQuery(SEARCH_INTENT_RESOURCES_SUGGESTIONS, {
    variables: {
      intentProjectId,
      input: {
        fullTextSearch: "",
        predicates: [],
        fields: [],
      },
    },
  });

  const allResourcesCount = useMemo(() => {
    return (
      data?.intentProject?.searchIntentResourcesSuggestions?.filteredCount ||
      previousData?.intentProject?.searchIntentResourcesSuggestions?.filteredCount ||
      0
    );
  }, [data, previousData]);

  return {
    allResourcesCount,
    loading,
  };
};

export default useSearchIntentResourcesSuggestions;
